import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.19, 1, 0.22, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionEyebrow = ({ children, className = "" }) => (
  <div className={`eyebrow eyebrow-gold ${className}`}>{children}</div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left", light = false }) => (
  <div className={`max-w-4xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow ? <SectionEyebrow className={light ? "text-white/70" : ""}>{eyebrow}</SectionEyebrow> : null}
    <h2
      className={`display display-lg mt-6 ${light ? "text-white" : ""}`}
      style={{ whiteSpace: "pre-line" }}
    >
      {title}
    </h2>
    {subtitle ? (
      <p className={`mt-6 text-base md:text-lg leading-relaxed ${light ? "text-white/70" : "text-brand-medium"} max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
        {subtitle}
      </p>
    ) : null}
  </div>
);

export const ArrowIcon = ({ className = "w-4 h-4" }) => (
  <svg className={`arrow ${className}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
